export default __webpack_public_path__ + "static/bytes-ibm-c35907d72288d5a9dfbd17654cccbf74.png";